import * as actions from "../constants/ActionTypes";
import deepEqual from "lib/deepEqual";

const initialState = {
    x: 0,
    y: 0,
    contents: null
};

export default function tooltipReducer(state = initialState, action = {}) {
    let {x, y, contents, type} = action;

    switch (type) {
        case actions.SET_TOOLTIP:
            if (state.contents !== contents && deepEqual(state.contents, contents)) {
                contents = state.contents;
            }

            return {x, y, contents};

        case actions.CLEAR_TOOLTIP:
            return initialState;

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/tooltip.js